export const LOG_LEVELS = {
    TRACE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    OFF: 99
} as const;

export const LOG_LEVEL_TO_LABEL: { [key: number]: keyof typeof LOG_LEVELS } = {
    1: 'TRACE',
    2: 'DEBUG',
    3: 'INFO',
    4: 'WARN',
    5: 'ERROR',
    99: 'OFF'
};